import {
  IonButton,
  IonContent,
  IonFooter,
  IonHeader,
  IonModal, IonTitle,
  IonToolbar
} from "@ionic/react";
import { useEffect, useState } from "react";
import { useLocalStorage } from "../hooks/useLocalStorage";

export const AgeCheckModal: React.FC = () => {
  const [isModalOpen, setIsOpenModal] = useLocalStorage<boolean>(
    "isModalOpen",
    true
  );
  const [openModal, setOpenModal] = useState<boolean>(isModalOpen);

  useEffect(() => {
    setOpenModal(isModalOpen);
    console.log(isModalOpen);
  }, [isModalOpen]);

  const message = "Please be advised that this website contains content and language and images not suitable for minors.  If you are under the age of 18 or are offended by adult-oriented websites, please browse elsewhere. By choosing to continue past this disclaimer, you release and discharge the owner of this website and all parties involved with the creation, maintenance and hosting of any and all liability which may arise from your actions.";

  function confirm() {
    setIsOpenModal(false);
    setOpenModal(false);
  }

  return (
    <IonModal
      canDismiss={true}
      isOpen={openModal}
      onDidDismiss={confirm}
      backdropDismiss={false}
    >
      <IonHeader className="ion-no-border">
        <IonToolbar>
          <IonTitle></IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent id="agemModal" className="ion-padding">
        <IonHeader className="ion-no-border" collapse="condense">
          <IonToolbar>
            <IonTitle size="large">Age Check</IonTitle>
          </IonToolbar>
        </IonHeader>
        <h4 className=" pt-14 text-ellipsis text-center origin-center justify-center text-base text-slate-600">
          {message}
        </h4>
      </IonContent>
      <IonFooter>
        <IonToolbar>
          <IonButton
            slot="end"
            color="medium"
            onClick={() => {
              window.location.href = "https://google.com";
            }}
          >
            Leave
          </IonButton>
          <IonButton slot="end" color="dark" onClick={confirm}>
            Enter
          </IonButton>
        </IonToolbar>
      </IonFooter>
    </IonModal>
  );
};
